// Cliente HTTP para comunicación con la API de SubiGol
import axios from 'axios'

// URL base de la API resuelta dinámicamente según el entorno y subdirectorio
const getApiUrl = () => {
  const configUrl = import.meta.env.VITE_API_URL
  if (configUrl && configUrl.startsWith('http')) {
    return configUrl
  }
  // En producción, deducir la ruta de la API a partir de la base dinámica detectada
  const base = window.__APP_BASE_URL__ || '/'
  return base + 'api'
}

const API_URL = getApiUrl()

// Instancia de Axios con configuración base
const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 15000,
})

// Interceptor de peticiones: inyectar token de autenticación
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('subigol_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Interceptor de respuestas: manejar errores globales
client.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si el servidor retorna 401, limpiar sesión y redirigir
    if (error.response?.status === 401) {
      localStorage.removeItem('subigol_token')
      localStorage.removeItem('subigol_user')
      
      const baseUrl = window.__APP_BASE_URL__ || '/'
      // Solo redirigir si no estamos ya en login
      if (!window.location.pathname.includes(baseUrl + 'login') && !window.location.pathname.includes('/login')) {
        window.location.href = baseUrl + 'login'
      }
    }
    return Promise.reject(error)
  }
)

export default client
